import { render, staticRenderFns } from "./form-car-valuation-existing-customer.vue?vue&type=template&id=3159baca"
import script from "./form-car-valuation-existing-customer.vue?vue&type=script&lang=js"
export * from "./form-car-valuation-existing-customer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports